import React from "react";
import Contacts from "./Contacts";

const ContactsContainer = (props) => {
  return <Contacts />;
};

export default ContactsContainer;
